import { render } from "./T-Full-Frame.vue?vue&type=template&id=68dff011"
import script from "./T-Full-Frame.vue?vue&type=script&lang=js"
export * from "./T-Full-Frame.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__